import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

const COLORS = { brussels: "#FBBC04", wallonia: "#FF7900", flanders: "#2DD4BF", unknown: "#666" };

export const RegionStats = () => {
  const { t } = useLang();
  const rg = t.dash.regions;
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/stats/regions").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const known = ["brussels", "wallonia", "flanders"].reduce((s, k) => s + data[k].total, 0);
  if (known === 0) return null;
  const max = Math.max(1, ...Object.values(data).map((v) => v.total));

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="region-stats-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-6">
        <MapPin className="w-4 h-4 text-[#FF7900]" /> {rg.title}
      </p>
      <div className="space-y-4">
        {["brussels", "wallonia", "flanders", "unknown"].map((k) =>
          data[k].total === 0 ? null : (
            <div key={k} data-testid={`region-row-${k}`}>
              <div className="flex justify-between text-xs mb-1.5">
                <span className="text-white/75 font-semibold">{rg[k]}</span>
                <span className="text-white/45">
                  {data[k].total} {rg.leads} · {data[k].converted} {rg.converted}
                </span>
              </div>
              <div className="h-2 bg-white/5 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-[width] duration-700"
                  style={{ width: `${(data[k].total / max) * 100}%`, background: COLORS[k] }}
                />
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
